import React, {useState, useEffect} from 'react';
import axios from "axios";
import config from "../../../config";


const useNotifications = (counter) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await axios.get(config.SYNCHROEU_URL + `/prometheus/api/v1/rules`);;
                setData(response.data.data.groups); // Save API data to state
                setLoading(false); // Data is loaded
            } catch (err) {
                setError("Error loading notifications data.");
                setLoading(false);
            }
        };

        fetchData();
    }, [counter]);

    return { data, loading, error };
};

export default useNotifications;